(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.LoggerJS = {}));
})(this, (function (exports) { 'use strict';

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }
  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }
  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * Checks if `value` is classified as an `Array` object.
   *
   * @static
   * @memberOf _
   * @since 0.1.0
   * @category Lang
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is an array, else `false`.
   * @example
   *
   * _.isArray([1, 2, 3]);
   * // => true
   *
   * _.isArray(document.body.children);
   * // => false
   *
   * _.isArray('abc');
   * // => false
   *
   * _.isArray(_.noop);
   * // => false
   */

  var isArray = Array.isArray;

  var isArray_1 = isArray;

  function getHashFromString() {
    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    if (!str) {
      return 0;
    }
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  // https://trendct.org/2016/01/22/how-to-choose-a-label-color-to-contrast-with-background/
  function getConstrast(_ref) {
    var _ref$light = _ref.light,
      light = _ref$light === void 0 ? '#ffffff' : _ref$light,
      _ref$dark = _ref.dark,
      dark = _ref$dark === void 0 ? '#000000' : _ref$dark,
      _ref$red = _ref.red,
      red = _ref$red === void 0 ? 0 : _ref$red,
      _ref$green = _ref.green,
      green = _ref$green === void 0 ? 0 : _ref$green,
      _ref$blue = _ref.blue,
      blue = _ref$blue === void 0 ? 0 : _ref$blue,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 128 : _ref$threshold;
    // let threshold = 123;
    var cBrightness = (red * 299 + green * 587 + blue * 114) / 1000;
    return cBrightness > threshold ? dark : light;
  }
  function generateColorFromString(str) {
    var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    if (!str) {
      return str;
    }
    var hash = getHashFromString(str);
    var red = hash >> 0 * 8 & 0xff;
    var green = hash >> 1 * 8 & 0xff;
    var blue = hash >> 2 * 8 & 0xff;
    var norm = function norm(str) {
      return str.length < 2 ? "0".concat(str) : str;
    };
    return {
      red: red,
      green: green,
      blue: blue,
      hex: "#".concat(norm(red.toString(16))).concat(norm(green.toString(16))).concat(norm(blue.toString(16))),
      rgb: "rgb(".concat(red, ", ").concat(green, ", ").concat(blue, ")"),
      rgba: "rgba(".concat(red, ", ").concat(green, ", ").concat(blue, ", ").concat(alpha, ")")
    };
  }

  var isIE = function isIE() {
    return navigator.userAgent.indexOf("MSIE") > -1 || navigator.userAgent.indexOf("Trident") > -1;
  };
  var customConsole = {
    debug: function debug(args) {
      console.debug(args);
    },
    trace: function trace(args) {
      console.trace(args);
    },
    log: function log(args) {
      console.log(args);
    },
    info: function info(args) {
      console.log(args);
    },
    warn: function warn(args) {
      console.warn(args);
    },
    error: function error(args) {
      console.error(args);
    },
    time: function time(args) {
      console.time(args);
    },
    timeEnd: function timeEnd(args) {
      console.timeEnd(args);
    },
    timeStamp: function timeStamp(args) {
      console.timeStamp(args);
    },
    count: function count(args) {
      console.count(args);
    },
    countReset: function countReset(args) {
      console.countReset(args);
    },
    dir: function dir(args) {
      console.dir(args);
    },
    dirxml: function dirxml(args) {
      console.dirxml(args);
    },
    clear: function clear(args) {
      console.clear(args);
    }
  };

  /**
   * @typedef {Object} Config
   * @property {Object} project Cuurent object values
   * @property {String} [project.name = null] Name of current object
   * @property {String} [project.style = null] Style of name
   * @property {Object} style Style config
   * @property {String} style.separator Style config
   * @property {String|String[]} style.delimiter Style config
   * @property {Number} style.maxStyledItem Style config
   * @property {Object} handler The handler options
   * @property {Console} [handler.type=console] The handler options
   * @property {String[]} [handler.overwrite] The handler options
   * @property {String[]} [handler.ignore] The handler options
   * @property {Object} debug debug  properties
   * @property {Boolean} debug.enabled debug  properties
   * @property {Number} [debug.level = 0] debug  properties
   * @property {String[]} [debug.only = 0] debug  properties
   * @property {String[]} [debug.ignore = 0] debug  properties
   */

  /**
   * Config for LoggerJS
   *  @type {Config}
   */
  var config = {
    clear: "background: transparent; color: inherit;",
    project: {
      name: null,
      style: null
    },
    style: {
      separator: "/",
      delimiter: ["[", "]"],
      maxStyledItem: 3
    },
    handler: {
      type: isIE() ? customConsole : console,
      formated: ["debug", "log", "info", "warn", "error", "group", "groupCollapsed"]
    },
    debug: {
      enabled: true,
      level: 0,
      only: [],
      // list pf property where should be debuged,
      ignore: [] // list of property where should be ignored
    }
  };

  /**
   * Proxy handler get
   *
   * @param {CustomLogger} target The Obk\ject where property we get
   * @param {String} key The key where we get
   * @returns <Function|String|Object>
   */
  var getHandler = function getHandler(target, key) {
    // If key is in `console` object
    if (~target.allHandlers.indexOf(key)) {
      if (target.isDebug(key)) {
        var consoleObj = config.handler;
        // if key function is formated
        if (~consoleObj.formated.indexOf(key)) {
          var _consoleObj$type$key;
          var params = formatConsoleOutput(target.base);
          target.base = [target.name];
          return (_consoleObj$type$key = consoleObj.type[key]).bind.apply(_consoleObj$type$key, [consoleObj.type].concat(_toConsumableArray(params)));
        } else {
          var _consoleObj$type;
          var _params = formatConsoleOutput(target.base);
          (_consoleObj$type = consoleObj.type).log.apply(_consoleObj$type, _toConsumableArray(_params).concat(["Label for `" + key + "`"]));
          return consoleObj.type[key];
        }
      } else {
        target.base = [target.name];
        return function () {};
      }
    } else if (Reflect.has(target, key)) {
      return Reflect.get(target, key); // target[key];
    } else {
      return Reflect.get(CustomLogger, key);
    }
  };

  /**
   * Proxy handler for class
   */
  var handler = {
    get: getHandler
  };
  var getPolyfill = function getPolyfill(target, handler) {
    target.allHandlers.forEach(function (el) {
      target[el] = function (args) {
        var consoleObj = config.handler.type;
        // let args = Array.prototype.slice.call(arguments);
        consoleObj[el](JSON.stringify(args));
      };
    });
    Object.keys(CustomLogger).forEach(function (el) {
      target[el] = CustomLogger[el];
    });
    ['subgroup'].forEach(function (el) {
      target[el] = target[el];
    });
    return target;
  };

  /**
   * Get style accorging name.
   * Style have background color in RGB fromat and constasted text color `white` or `black`
   * @param {string} name Name to get colors
   * @returns {String}  The style for `name` in format `{background: <color>, color: <color>}`
   */
  function getStyle(name) {
    var _generateColorFromStr = generateColorFromString(name),
      red = _generateColorFromStr.red,
      green = _generateColorFromStr.green,
      blue = _generateColorFromStr.blue,
      rgb = _generateColorFromStr.rgb;
    var text = getConstrast({
      red: red,
      green: green,
      blue: blue,
      light: "#ffffff",
      dark: "#000000"
    });
    return "\n    background: ".concat(rgb, ";\n    color: ").concat(text, ";\n  ");
  }
  function formatDelimiters(array) {
    var delimiter = config.style.delimiter;
    var len = isArray_1(delimiter) ? delimiter.length : 1;
    var left = delimiter[0];
    var right = delimiter[1];
    var center = delimiter;
    var name = config.project.name;
    if (!isArray_1(array)) {
      if (len === 2) {
        return "".concat(left).concat(array).concat(right);
      }
      return "".concat(array);
    }
    return array.map(function (el, index) {
      if (len === 2) {
        return "".concat(left).concat(el).concat(right);
      }
      if (index === 0 && !name) {
        return "".concat(el);
      } else {
        return "".concat(center).concat(el);
      }
    });
  }

  /**
   * Function for formating output
   *
   * @param {String[]} array Array with functions block
   * @param {Config} _config Config for formating
   * @returns {Array} the arguments Array
   */
  function formatConsoleOutput(array) {
    array = formatDelimiters(array);
    var base = "%c%s%c";
    var baseShort = "%s";
    var elemets = [];
    var str = "";
    var maxStyledItemsCount = config.style.maxStyledItem;
    if (config.project.name) {
      maxStyledItemsCount = maxStyledItemsCount - 1;
      str = base;
      elemets = [config.project.style, formatDelimiters(config.project.name), config.clear];
      if (isIE()) {
        str = baseShort;
        elemets = [formatDelimiters(config.project.name)];
      }
    }
    array.forEach(function (el, index) {
      if (index < maxStyledItemsCount && !isIE()) {
        str += base;
        var style = getStyle(el);
        elemets.push(style);
        elemets.push(el);
        elemets.push(config.clear);
      } else {
        str += baseShort;
        elemets.push(el);
      }
    });
    return [str].concat(_toConsumableArray(elemets));
  }
  var CustomLogger = /*#__PURE__*/function () {
    function CustomLogger() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      _classCallCheck(this, CustomLogger);
      this.name = name;
      this.base = this.name ? [this.name] : [];
      this.allHandlers = Object.keys(config.handler.type);
      try {
        return this.proxyHandler = new Proxy(this, handler);
      } catch (err) {
        // console.error(`[LoggerJS] Error with proxy Object`, err);
        return this.proxyHandler = getPolyfill(this);
      }
    }
    _createClass(CustomLogger, [{
      key: "isDebug",
      value: function isDebug() {
        var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (!config.debug.enabled || !key) {
          return config.debug.enabled;
        }
        var level = config.debug.level;
        if (level > 3) {
          return false;
        } else if (level <= 0) {
          return true;
        } else if (level === 3) {
          var ErrorLevel = ["error", "assert"];
          return ErrorLevel.indexOf(key) > -1;
        } else if (level === 2) {
          var WarnLevel = ["error", "assert", "warn"];
          return WarnLevel.indexOf(key) > -1;
        }
        var DebugLevel = ["log", "debug"];
        return DebugLevel.indexOf(key) === -1;
      }
    }], [{
      key: "config",
      get: function get() {
        return config;
      },
      set: function set(_config) {
        if (_config.handler) {
          if (_config.handler.type) {
            config.handler.type = _config.handler.type;
          }
          if (_config.handler.formated) {
            config.handler.formated = _config.handler.formated;
          }
        }
        if (_config.project) {
          config.project = Object.assign({}, _config.project);
          config.project.style = !config.project.style && config.project.name ? getStyle(config.project.name) : config.project.style;
        }
        if (_config.style) {
          config.style.separator = _config.style.separator ? _config.style.separator : config.style.separator;
          config.style.delimiter = _config.style.delimiter ? _config.style.delimiter : config.style.delimiter;
          config.style.maxStyledItem = _config.style.maxStyledItem ? _config.style.maxStyledItem : config.style.maxStyledItem;
        }
        if (_config.debug) {
          config.debug = Object.assign({}, _config.debug);
        }
        // config = merge({}, config, _config);
        // console.log(_config);
        this.allHandlers = Object.keys(config.handler.type);
      }
    }, {
      key: "subgroup",
      value: function subgroup() {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
        name = name || "";
        this.base = [].concat(_toConsumableArray(this.base), _toConsumableArray(name.split(config.style.separator)));
        return this.proxyHandler;
      }
    }, {
      key: "setConfig",
      value: function setConfig() {
        var _config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        if (!_config) {
          throw new Error("Property 'config' cannot be empty");
        }
        if (_config.clear) {
          throw new Error("Property 'config.clear' is readonly. Value is  '".concat(this.config.clear, "'"));
        }
        CustomLogger.config = _config;
        // NOTE: config change
        // this.config = config;
        // this.allHandlers = Object.keys(this.config.handler.type);
      }
    }]);
    return CustomLogger;
  }();

  var LoggerMixin$1 = function LoggerMixin(name) {
    return {
      created: function created() {
        this.$options[name] = new CustomLogger(this.$options.name);
        this[name] = this.$options[name];
      },
      destroyed: function destroyed() {
        this[name] = this.$options[name] = null;
      }
    };
  };
  function install$1(Vue, options) {
    var pluginName = options.pluginName || "LoggerJS";
    CustomLogger.setConfig(options);
    Vue.mixin(LoggerMixin$1(pluginName));
  }

  var LoggerMixin = function LoggerMixin(name) {
    return {
      created: function created() {
        if (this.logging) {
          this.$options[name] = new CustomLogger(this.$options.name);
          this[name] = this.$options[name];
        }
      },
      unmounted: function unmounted() {
        if (this.logging) {
          this[name] = this.$options[name] = null;
        }
      }
    };
  };
  function install(app, options) {
    var pluginName = options.pluginName || "LoggerJS";
    CustomLogger.setConfig(options);
    app.mixin(LoggerMixin(pluginName));
  }

  var LoggerVuePlugin = {
    install: install$1
  };
  var LoggerVue3Plugin = {
    install: install
  };
  var Logger = CustomLogger;

  exports.Logger = Logger;
  exports.LoggerVue3Plugin = LoggerVue3Plugin;
  exports.LoggerVuePlugin = LoggerVuePlugin;
  exports["default"] = Logger;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
